import {Product} from '../../../../shared/types';

interface Messages {
    shareRate: string;
    fnShareRate: string;
}

const formatShareRate = <T extends Product>(product: T, messages: Messages) => {
    const {title = 'FORTNITE', shareRate = 5} = product || {};
    switch (title.toUpperCase()) {
        case 'FN':
        case 'FORTNITE': {
            return messages.fnShareRate;
        }
        case 'BATTLE BREAKERS': {
            return '';
        }
        default: {
            return `${shareRate}% ${messages.shareRate}`;
        }
    }
};

export default formatShareRate;
